import React from "react";
import Box from "@material-ui/core/Box";
import { Typography, Card } from "@material-ui/core";
import ReactHtmlParser from "react-html-parser";

const typo = ({ text, variant, color, align }, key) => (
  <Typography
    key={key}
    style={!!color ? { color: color } : { fontWeight: 450 }}
    color="textSecondary"
    align={align || "center"}
    variant={variant || "subtitle2"}
  >
    {text || ""}
  </Typography>
);

const spaceBr = (key) => (
  <div key={key} className="my-2">
    <br />
  </div>
);

const HeaderSubtitle = (elements) => (
  <Card className="mt-4 py-4">
    <Box component="span">
      <div className="px-4">
        {!!elements &&
          Object.values(elements).map((element, key) =>
            !!element.space ? spaceBr(key) : typo(element, key)
          )}
      </div>
    </Box>
  </Card>
);

export default HeaderSubtitle;
